import { PropTypes } from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import useDeviceDetect from "../../hooks/useDeviceDetect";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import AutoScroll from "../al_components/AutoScroll";

import "./mediaLogosBanner/MediaLogosBanner.scss";

function MediaLogosBanner({ content }) {
  const { isMobile } = useDeviceDetect();

  const logos = isMobile ? content.logos : [...content.logos, ...content.logos, ...content.logos];

  return (
    <div className="media-logos-banner">
      <h4
        className="media-logos-banner__title h4 h4--bold h4--uc"
        style={{
          borderColor: isMobile ? "#f8f5f1" : content?.titleBackgroundColor,
          backgroundColor: isMobile ? "#f8f5f1" : content?.titleBackgroundColor,
          color: isMobile ? content?.titleColors?.mobile : content?.titleColors?.desktop,
        }}
      >
        {content.title}
      </h4>
      <AutoScroll gap={isMobile ? "19px" : "27px"} speed={2}>
        <div className="media-logos-banner__logos">
          {logos.map((logo) => {
            const image = isMobile
              ? getImage(logo.mobileImage.gatsbyImageData)
              : getImage(logo.desktopImage.gatsbyImageData);
            return <GatsbyImage key={logo.id} image={image} alt={logo.altText} />;
          })}
        </div>
      </AutoScroll>
    </div>
  );
}

MediaLogosBanner.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    titleBackgroundColor: PropTypes.string,
    titleColors: PropTypes.shape({
      mobile: PropTypes.string,
      desktop: PropTypes.string,
    }),
    logos: PropTypes.arrayOf(
      PropTypes.shape({
        altText: PropTypes.string,
        desktopImage: PropTypes.shape({}),
        mobileImage: PropTypes.shape({}),
      })
    ),
  }),
};

export default withALErrorBoundary({
  name: "MediaLogosBanner",
  priority: "P4",
})(MediaLogosBanner);
